export default "__VITE_ASSET__BfwklOha__"